<template>
  <div>
    <div class="card-header pl-0">
      <div class="d-flex justify-content-between align-items-center">
        <div class="dropdown mr-3 d-none">
          <button
            class="btn btn-card-header dropdown-toggle"
            type="button"
            id="inspectorDropdown"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <img src="~@/assets/addplus_icon.svg" class="heading-icon mr-2"/>
            <span class="pr-2 text-capitalize"> Add</span>
          </button>

          <ul class="dropdown-menu" aria-labelledby="inspectorDropdown">
            <li class="d-none"><span class="dropdown-item" @click="activeComponent = 'default'">Default</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'main'">Main</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'animations'">Animations</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'light'">Light</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'sound'">Sound</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'movement'">Movement</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'effects'">Effects</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'tts'">TTS</span></li>
          </ul>
        </div>
        <span class="ml-3"><img class="heading-icon mr-2" src="~@/assets/device_hub_icon.svg"/> Inspector</span>
        <span class="text-primary ml-3">
          {{ activeComponentTitle }}
        </span>


        <div class="dropdown ml-5 d-none">
          <button
            class="btn btn-dark dropdown-toggle"
            type="button"
            id="inspectorDropdown2"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <img src="~@/assets/addplus_icon.svg" class="heading-icon mr-2"/>
            <span class="pr-2 text-capitalize"> Others</span>
          </button>

          <ul class="dropdown-menu" aria-labelledby="inspectorDropdown2">
            <li><span class="dropdown-item" @click="activeComponent = 'object 3d'">Object 3d</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'environment 3d'">Environment 3D</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'media-sounds'">Media-Sounds</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'media-videos'">Media-Videos</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'media-images'">Media-Images</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'ds-dynamic text'">DS-Dynamic Text</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'ds-object 2d'">DS-Object 2D</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'standalone lighting'">Standalone Lighting</span>
            </li>
            <li><span class="dropdown-item" @click="activeComponent = 'standalone effects'">Standalone Effects</span>
            </li>
            <li><span class="dropdown-item" @click="activeComponent = 'object 2D'">Object 2D</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'wof'">WOF</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'chatbot'">Chatbot</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'verbal-speech'">Verbal-Speech</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'probability'">Probability</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'trivia'">Trivia</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'touch 2D'">Touch 2D</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'touch 3D'">Touch 3D</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'event'">Event</span></li>
            <li><span class="dropdown-item"
                      @click="activeComponent = 'universal conditions'">Universal Conditions</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'universal filtering'">Universal Filtering</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="inspector-wrapper">
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'experienceInspector'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-wrap/experienceInspector.vue